import * as React from 'react';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import CardActions from '@mui/material/CardActions';
import { CardHeader, Divider, IconButton, ListItemIcon, Menu, MenuItem, Stack, Tooltip } from '@mui/material';
// import MoreVertIcon from '@mui/icons-material/MoreVert';
import EditNoteIcon from '@mui/icons-material/EditNote';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import CheckIcon from '@mui/icons-material/Check';
import NotesIcon from '@mui/icons-material/Notes';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

import Badge, { badgeClasses } from '@mui/material/Badge';
import { styled } from '@mui/material/styles';

import { useParams } from 'react-router-dom';
import { useDrop } from 'react-dnd'
import { useDrag } from 'react-dnd'

import { blueGrey } from '@mui/material/colors';
import KanbanCardDialog from './KanbanCardDialog';

import { green } from '@mui/material/colors';
import * as lstCor from '@mui/material/colors';

import EtiquetaMenu from '../../util/EtiquetasMenu';
import { ChatBubbleOutlineOutlined, ChatBubbleOutlined, Done, FileCopy } from '@mui/icons-material';
import KanbanCopiarTemplatePopover from './KanbanCopiarTemplatePopover';
import KanbanConcluirCardModal from './KanbanConcluirCardModal';
import KanbanCardMoverMenu from './KanbanCardMoverMenu';
import KanbanCarkArquivarMenu from './KanbanCardArquivarMenu';
import Service from '../../../util/Service';
import KanbanCardMembrosMenu from './KanbanCardMembrosMenu';
import { TYPES } from '../../../util/ServiceWS';

const CartBadge = styled(Badge)`
  & .${badgeClasses.badge} {
    top: -6px;
    right: -3px;
  }
`;
export default function KanbanCard(props) {
    const { projeto, papeis, temAcessoBasico, cartao, col, kanban, action, lista, setLista, index, moveCard, id, setShowBtnSalvar } = props;
    const [isEdit, setIsEdit] = React.useState(false);
    const [openCardDialog, setOpenCardDialog] = React.useState(false);
    const [cartaoCorrente, setCartaoCorrente] = React.useState(null);

    const [anchorElEtiqueta, setAnchorElEtiqueta] = React.useState(null);
    const openEtiqueta = Boolean(anchorElEtiqueta);

    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const params = useParams();
    const ref = React.useRef(null);

    React.useEffect(() => {
        if (cartao) {
            const idCartao = params.idCartao;
            if (cartao.id === idCartao) {
                setOpenCardDialog(true);
            }
            setCartaoCorrente(cartao);
        }
    }, [cartao])

    const [{ handlerId }, drop] = useDrop({
        accept: 'card',
        collect(monitor) {
            return {
                handlerId: monitor.getHandlerId(),
            }
        },
        hover(item, monitor) {
            if (!ref.current) {
                return
            }
            const dragIndex = item.index
            const hoverIndex = index
            // Don't replace items with themselves
            if (dragIndex === hoverIndex) {
                return
            }
            // Determine rectangle on screen
            const hoverBoundingRect = ref.current?.getBoundingClientRect()
            // Get vertical middle
            const hoverMiddleY =
                (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2
            // Determine mouse position
            const clientOffset = monitor.getClientOffset()
            // Get pixels to the top
            const hoverClientY = clientOffset.y - hoverBoundingRect.top
            // Only perform the move when the mouse has crossed half of the items height
            // When dragging downwards, only move when the cursor is below 50%
            // When dragging upwards, only move when the cursor is above 50%
            // Dragging downwards
            if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
                return
            }
            // Dragging upwards
            if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
                return
            }


            moveCard(dragIndex, hoverIndex, cartao.id, item.id)
            item.index = hoverIndex
        }
    })

    const [{ isDragging }, drag] = useDrag({
        type: 'card',
        item: () => {
            return { id, index }
        },
        end: (item, monitor) => {
            setShowBtnSalvar(true);
        },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
    })

    const opacity = isDragging ? 0 : 1


    const handleClick = (event) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    function handleEnter(e) {
        setIsEdit(true);
    }
    function handleout(e) {
        setIsEdit(false);
        handleClose();
    }
    function tipMembros() {
        let txt = '';
        if (cartao.membros && cartao.membros.length > 0) {
            if (cartao.membros.length == 1) {
                txt = "Responsável: " + cartao.membros[0].nome;
            } else if (cartao.membros && cartao.membros.length < 4) {
                const membros = cartao.membros;
                txt = "Membros: "
                for (let x in membros) {
                    txt += membros[x].nome + ", ";
                }
                txt = txt.substring(0, txt.length - 2);
            } else {
                txt = "Equipe com " + cartao.membros.length + " membros";
            }
        }
        return txt;
    }
    function hasMore() {
        if (cartao.descricao) return true;
        if (cartao.comentarios) return true;
        if (cartao.esforco && cartao.esforco > 0) return true;
        if (cartao.membros && cartao.membros.length > 0) return true;
        return false;
    }
    function handleAbrirCartao(event) {
        handleClose();
        // handleClick()
        // setAnchorEl(event.currentTarget);
        setOpenCardDialog(true);
    }
    function getCor(c) {
        if (!kanban.lstEtiqueta) {
            return 'gray';
        }

        const tag = kanban.lstEtiqueta.find(e => e.id === c);
        if (!tag) return 'gray';

        return lstCor[tag.nome][tag.tom];
    }
    function preAction(item) {
        if (item.type === TYPES.etiqueta) {
            setCartaoCorrente(item.dado);
        }
        if (action) action(item);
    }
    function handleTemplateDone(dado) {
        handleClose()
        action({
            type: TYPES.templateCopiado,
            dado: dado
        });
    }
    function handleInformarCartaoConcluido(dado){
        handleClose()
        action({
            type: TYPES.cardConcluido,
            dado: dado
        });
    }
    function handleArquivarCartao(){
        handleClose();
        const dado = {
            id: cartao.id,
        }
        Service.POST('/api/security/projeto/kanban/cardArquivar', dado).then(r => {
            action({
                type: TYPES.cardArquivar,
            });
        })

    }
    function handleToggleMembro(dado){
        action({
            type: TYPES.cardToggleMembro,
            dado: dado
        });
    }
    function handleMoverCard(dado){
        handleClose();
        action({
            type: TYPES.cardMoveOutraColuna,
            dado: dado
        });
    }

    if (!cartaoCorrente) return;

    const more = hasMore();

    drag(drop(ref));
    return (
        <Card ref={ref}
            sx={{
                ml: -1,
                mr: -1,
                ":hover": {
                    borderColor: blueGrey[500],
                    cursor: 'pointer'
                }
            }}
            variant="outlined"
            onMouseOver={handleEnter}
            onMouseLeave={handleout}
        >
            {cartaoCorrente.lstEtiqueta &&
                <Stack direction="row" spacing={{ xs: 1, sm: 2, md: 0.3 }}>
                    {cartaoCorrente.lstEtiqueta.map((e, id) =>
                        <div key={id} style={{
                            width: '40px',
                            height: '10px',
                            // border: '2px solid #000',
                            borderRadius: '10px',
                            background: getCor(e)
                        }} />)}
                </Stack>}
            <CardHeader
                sx={{ height: more ? 30 : 60 }}
                action={isEdit &&
                    <IconButton aria-label="settings" size='small' onClick={handleClick} disabled={!temAcessoBasico}>
                        <EditNoteIcon />
                    </IconButton>
                }
                title={
                    <Typography variant="body2" sx={{ color: 'text.primary' }}>
                        {cartaoCorrente.concluido && <CheckIcon fontSize="small" sx={{ color: green[500] }} />}
                        {cartaoCorrente.nome}
                    </Typography>
                }
                onClick={(e) => {
                    setOpenCardDialog(true);
                }}
            />
            {more &&
                <CardActions disableSpacing sx={{ height: 30 }}
                    onClick={(e) => {
                        setOpenCardDialog(true);
                    }}
                >
                    {cartaoCorrente.descricao &&
                        <Tooltip title='Esse cartão tem uma descrição'>
                            <IconButton aria-label="add to favorites" size='small'>
                                <NotesIcon />
                            </IconButton>
                        </Tooltip>
                    }
                    {cartaoCorrente.comentario && cartaoCorrente.comentario.length > 0 && <IconButton aria-label="share" size='small'>
                        <ChatBubbleOutlined />
                    </IconButton>}
                    {cartaoCorrente.esforco > 0 &&
                        <Tooltip title={"Esfoço: " + cartaoCorrente.esforco + " H"}>
                            <IconButton aria-label="share" size='small'>
                                <AccessTimeIcon />
                            </IconButton>
                        </Tooltip>}
                    {cartaoCorrente.membros && cartaoCorrente.membros.length > 0 &&
                        <Tooltip title={tipMembros()}>
                            <IconButton aria-label="share" size='small'>
                                <AccountCircleIcon />
                                {cartaoCorrente.membros.length > 1 && 
                                <CartBadge badgeContent={cartaoCorrente.membros.length} color="primary" overlap="circular" />}
                            </IconButton>
                        </Tooltip>}
                </CardActions>}

            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                slotProps={{
                    list: {
                        'aria-labelledby': 'basic-button',
                    },
                }}
                size='small'
            >
                <MenuItem onClick={handleAbrirCartao}>
                    <ListItemIcon size='small' >
                        <OpenInNewIcon fontSize="small" />
                    </ListItemIcon>
                    Abrir cartão
                </MenuItem>
                <MenuItem onClick={(e) => setAnchorElEtiqueta(e.currentTarget)}>
                    <ListItemIcon size='small'>
                        <LocalOfferIcon fontSize="small" />
                    </ListItemIcon>
                    Editar Etiquetas</MenuItem>
                {/* <MenuItem onClick={handleClose}>
                    <ListItemIcon size='small'>
                        <PersonIcon fontSize="small" />
                    </ListItemIcon>
                    Alterar Membros</MenuItem> */}
                <KanbanCardMembrosMenu 
                    kanban={kanban} 
                    cartao={cartao}
                    action={handleToggleMembro}
                />
                <KanbanCardMoverMenu 
                    action={handleMoverCard} col={col} kanban={kanban} 
                    cartao={cartao}
                />
                {cartaoCorrente && !cartaoCorrente.concluido && 
                    <KanbanConcluirCardModal action={handleInformarCartaoConcluido} cartao={cartaoCorrente} />
                }
                {cartaoCorrente && cartaoCorrente.concluido &&
                    <KanbanCarkArquivarMenu action={handleArquivarCartao}/>
                }
                {cartaoCorrente && cartaoCorrente.esforco === 0 &&
                    [
                        <Divider />,
                        <KanbanCopiarTemplatePopover cartao={cartaoCorrente} action={handleTemplateDone} />
                    ]
                }
            </Menu>
            <EtiquetaMenu
                anchorEl={anchorElEtiqueta} open={openEtiqueta}
                kanban={kanban}
                cartao={cartaoCorrente}
                handleClose={() => setAnchorElEtiqueta(null)}
                action={preAction}
                TYPES={TYPES}
            />
            <KanbanCardDialog projeto={projeto} papeis={papeis}
                open={openCardDialog}
                setOpen={setOpenCardDialog}
                cartao={cartaoCorrente}
                col={col}
                kanban={kanban}
                action={action}
                TYPES={TYPES}
                temAcessoBasico={temAcessoBasico}
                handleMoverCard={handleMoverCard}
            />
        </Card>
    );
}
